<template>
  <div class="htgl-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.bid" style="width: 120px" clearable>
                <el-option v-for="b in brandList" :label="b.brand_name" :value="b.brand_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search" />
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item style="float: right">
              <el-button type="primary" size="small" @click="editRow(null)" icon="el-icon-plus">添加合同</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" v-loading="loading">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%;margin-bottom: 20px">
              <el-table-column
                prop="code"
                label="合同编号"
                width="120"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="reftime"
                label="更新时间"
                width="160"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="brandname"
                label="品牌"
                width="90"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="name"
                label="合同名称"
                width="160"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="合同原件"
                min-width="120"
                show-overflow-tooltip>
                <template slot-scope="scope" >
                  <el-button icon="el-icon-document" @click="downLoad(scope.row)" size="mini" type="text">{{ scope.row.filename }}.{{ scope.row.filetype}}</el-button>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="180"
                fixed="right"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-edit" @click="editRow(scope.row)" size="mini">编辑</el-button>
                  <el-button icon="el-icon-delete" @click="delRow(scope.row)" size="mini">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editDialog"
      width="40%"
      :destroy-on-close="true"
      :append-to-body="true"
      :lock-scroll="true">
      <el-form size="small" ref="eForm" :model="eForm" label-width="80px" :rules="eRules">
        <el-form-item label="合同编号" prop="code">
          <el-input show-word-limit maxlength="20" v-model="eForm.code" placeholder="请输入合同编号"/>
        </el-form-item>
        <el-form-item label="所属品牌" prop="bid">
          <el-select v-model="eForm.bid" filterable placeholder="请选择品牌">
            <el-option v-for="item in brandList" :label="item.brand_name" :value="item.brand_id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="合同名称" prop="name">
          <el-input show-word-limit maxlength="20" v-model="eForm.name" placeholder="请输入合同名称"/>
        </el-form-item>
        <el-form-item label="合同原件" prop="fileid">
          <SingleFile :key="eForm.key" v-model="eForm.fileid" :accept="'.pdf'" :old="oldFile" :tip="'只能上传pdf'" />
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button :loading="editLoading" type="primary" @click="submitEdit">立即提交</el-button>
          <el-button @click="editDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getContractList, getBrandList, addOrEditContract, delContract } from '@/api/work'
import SingleFile from '../../../components/upload/SingleFile'
import { getFileInfo } from '@/api/pub'
export default {
  name: 'htgl',
  computed: {
    user: getUser
  },
  components: {
    SingleFile
  },
  data() {
    return {
      brandList: [],
      searchForm: {
        search: '',
        bid: null
      },
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editTitle: '',
      editDialog: false,
      oldFile: [],
      eForm: {
        cid: '0',
        code: '',
        name: '',
        fileid: null,
        bid: null,
        key: ''
      },
      eRules: {
        code: [{ required: true, message: '请输入合同编号', trigger: 'blur' }],
        name: [{ required: true, message: '请输入合同名称', trigger: 'blur' }],
        fileid: [{ required: true, message: '请上传合同原件', trigger: 'change' }],
        bid: [{ required: true, message: '请选择所属品牌', trigger: 'change' }]
      },
      editLoading: false
    }
  },
  created() {
    this.getData()
    this.getBrandList()
  },
  methods: {
    submitEdit() {
      this.$refs['eForm'].validate((valid) => {
        if (valid) {
          if (!this.editLoading) {
            this.editLoading = true
            const data = {
              cid: this.eForm.cid,
              code: this.eForm.code,
              fileid: this.eForm.fileid,
              name: this.eForm.name,
              bid: this.eForm.bid
            }
            addOrEditContract(data).then(response => {
              this.$message({
                message: response.msg,
                type: 'success'
              })
              this.editLoading = false
              this.editDialog = false
              this.getData()
            }).catch(() => {
              this.editLoading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    },
    editRow(row) {
      if (row !== null) {
        this.editTitle = '编辑合同'
        this.oldFile = [{ id: row.fileid, name: row.filename + '.' + row.filetype }]
        this.eForm = {
          cid: row.cid,
          code: row.code,
          name: row.name,
          fileid: row.fileid,
          bid: row.bid,
          key: new Date().getTime().toString()
        }
      } else {
        this.editTitle = '添加合同'
        this.oldFile = []
        this.eForm = {
          cid: '0',
          code: '',
          name: '',
          fileid: null,
          bid: null,
          key: new Date().getTime().toString()
        }
      }
      this.editDialog = true
    },
    delRow(row) {
      this.$confirm('您确定要删除 “' + row.code + '” 合同吗?', '提示', {
        confirmButtonText: '是的',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        delContract({ cid: row.cid }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    },
    downLoad(row) {
      getFileInfo({ fileid: row.fileid }).then(response => {
        const a = document.createElement('a')
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                  href: response.data.copyPath,
                  target: '_blank',
                  download: `${response.data.dName}.${response.data.dType}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    getBrandList() {
      // TODO 这里是写死的之后新增品牌还要改
      getBrandList().then(response => {
        let _brandList = []
        for (const b of response.data) {
          // 杭州乔金斯科技集团有限公司
          if (this.user.dGroupid === 1) {
            if (b.brand_id == 3) {
              _brandList.push(b)
            }
          } 
          // 浙江耐思迪家居有限公司
          else if (this.user.dGroupid === 2) {
            if (b.brand_id == 1 || b.brand_id == 2) {
              _brandList.push(b)
            }
          } 
          // 帆向
          else if (this.user.dGroupid === 35) {
            if (b.brand_id == 4) {
              _brandList.push(b)
            }
          } 
        }
        this.brandList = _brandList
      }).catch(() => {})
    },
    Search() {
      this.currentPage = 1
      this.getData()
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        bid: this.searchForm.bid,
        groupid: this.user.dGroupid,
        page: this.currentPage,
        limit: this.pageSize
      }
      getContractList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.htgl-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
